import { call, put, takeLatest } from "redux-saga/effects";
import { httpGetQuizathonLeaderBoard } from "../../../services/quizathon";
import {
  getParticipantLeaderboardFailure,
  getParticipantLeaderboardStart,
  getParticipantLeaderboardSuccess,
} from "../reducer";
import { networkErrorHandler } from "../../../utils/errorHandlers";

function* getParticipantLeaderboard({ payload }) {
  const response = yield call(httpGetQuizathonLeaderBoard, payload);
  const { success, raw, message } = response;
  if (success) {
    yield put(getParticipantLeaderboardSuccess(raw));
  } else {
    yield put(getParticipantLeaderboardFailure(message || raw?.error));
    networkErrorHandler(response?.statusCode, message || raw?.error);
  }
}

export default function* onGetParticipantLeaderboard() {
  yield takeLatest(getParticipantLeaderboardStart.type, getParticipantLeaderboard);
}
